// @MX:ANCHOR: [AUTO] china-inapi 제조사 목록 API wrapper — 작업지시서 Step3 제조사 선택에서 fan_in >= 3 예상
// @MX:REASON: [AUTO] GET /china/manufacturers 단일 엔드포인트로 Step3, WorkOrder 관련 컴포넌트가 공유
import { chinaInapi } from './chinaInapi';

/**
 * 제조사 목록 조회 (china-inapi)
 * @param {Object} params - 쿼리 파라미터 (medicalDept, productType 등)
 * @returns {Promise} axios 응답 — response.data 가 flat 배열
 */
export function getManufacturers(params = {}) {
  return chinaInapi.get('/china/manufacturers', { params });
}
